import axios from "axios";
// import appConfig from '../configs/app.config'
// import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from '../constants/api.constant'
// import { PERSIST_STORE_NAME } from '../constants/app.constant'
// import { onSignOutSuccess } from '../store/auth/sessionSlice'

const unauthorizedCode = [401];

const BaseService = axios.create({
  timeout: 60000,
  baseURL: "https://vaishnaviprofile-pvt-ltd.5techg.com/api/v1/web/company",
  // "http://localhost:5004/api/v1/web/company",
});

BaseService.interceptors.request.use(
  (config) => {
    const rawPersistData = localStorage.getItem("token");
    // console.log("rawPersistData", rawPersistData);

    // console.log("persistData", rawPersistData);

    let accessToken = rawPersistData ? rawPersistData : null;

    // console.log(accessToken);
    if (accessToken) {
      config.headers["Authorization"] = `${"Bearer "}${accessToken}`;
    }
    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

BaseService.interceptors.response.use(
  (response) => {
    if (response.data.code === 403) {
      localStorage.removeItem("UserData");
      localStorage.removeItem("token");
      window.location.href = "/login";
    }

    return response;
  },
  (error) => {
    const { response } = error;

    return Promise.reject(error);
  }
);

export default BaseService;
